export default __webpack_public_path__ + "static/media/07.ef2fea7c.jpg";